"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const merlin_input_stepper_1 = require("@travelnest/merlin.input-stepper");
const __1 = require("../../../../");
const data_1 = require("../../../../hooks/data");
const autosave_1 = require("../../../../hooks/autosave");
const TaskPage_1 = require("../../base/TaskPage");
const merlin_info_panels_1 = require("@travelnest/merlin.info-panels");
const accordion_1 = require("../../../components/accordion");
const Button_1 = require("../../../components/button/Button");
const IconButton_1 = __importDefault(require("../../..//components/button/IconButton"));
const Paragraph_1 = require("../../../components/paragraph/Paragraph");
const merlin_select_1 = require("@travelnest/merlin.select");
const theme_1 = __importDefault(require("../../../components/styles/theme"));
const data_2 = require("./data");
const capacity_1 = require("./capacity");
const constants_1 = require("../../../../tasks/constants");
const Spacer_1 = require("../../../components/spacer/Spacer");
const HorizontalRule_1 = require("../../../components/horizontal-rule/HorizontalRule");
const validation_1 = require("../../../../hooks/validation");
const InlineMessage_1 = require("../../../components/inline-message/InlineMessage");
const Heading_1 = require("../../../components/heading/Heading");
const MarginWrapper_1 = require("../../../components/margin/MarginWrapper");
const BedPickerWrapper = styled_1.default.div `
	border: 1px solid ${theme_1.default.colours.neutral.light};
	border-radius: 5px;
	padding: 1rem;
	max-width: 335px;
	flex: 1 0 100%;
	margin: 0 ${theme_1.default.layout.spacing.standard} ${theme_1.default.layout.spacing.standard} 0;

	p {
		font-weight: 400;
		color: ${theme_1.default.colours.neutral.darkest};
		margin-top: 1rem;
		margin-bottom: 0.25rem;
	}

	.bed-picker__button-wrapper {
		padding-top: 1rem;
	}
`;
const BedPickerFlexWrapper = styled_1.default.div `
	display: flex;
	flex-wrap: wrap;
`;
const BedPicker = (props) => {
    const { bed, bedroomId, index, bedTypes, removeBed, setBedType } = props;
    return React.createElement(BedPickerWrapper, null,
        React.createElement(merlin_select_1.Select, { label: `Bed ${index + 1}`, id: `${bedroomId}-bed-picker-${index + 1}`, value: bed.bed_type, onChange: (e) => setBedType(e.target.value, index) }, bedTypes === null || bedTypes === void 0 ? void 0 : bedTypes.map((b, i) => {
            return React.createElement("option", { key: i, value: b.name }, b.display_name);
        })),
        React.createElement("div", { className: "bed-picker__button-wrapper" },
            React.createElement(Button_1.Button, { onClick: () => removeBed(index) }, "Remove bed")));
};
// Component to edit each bedroom individually
const BedroomEdit = (props) => {
    const { bedroom: { id, beds }, bedroomNumber, dispatch, bedTypes } = props;
    const removeBed = (bed) => {
        dispatch({ type: 'removeBed', bedroomId: id, bed });
    };
    const setBedType = (bedType, bed) => {
        dispatch({ type: 'setBedType', bedroomId: id, bed, bedType });
    };
    return (React.createElement(accordion_1.Accordion, { persistenceId: `tn-bedroom-${id}` },
        React.createElement(accordion_1.AccordionHeader, null,
            React.createElement(accordion_1.DefaultAccordionHeading, { heading: `Bedroom ${bedroomNumber}`, subheading: `${beds.length} bed${beds.length !== 1 ? 's' : ''}` })),
        React.createElement(accordion_1.AccordionItem, { noBorder: true },
            React.createElement(IconButton_1.default, { onClick: () => dispatch({ type: 'newBed', bedroomId: id }), icon: "plus", colour: "black" }, "Add another bed"),
            React.createElement(Spacer_1.Spacer, null),
            beds.length === 0 && React.createElement(React.Fragment, null,
                React.createElement(InlineMessage_1.InlineError, { text: "You must specify at least one bed." }),
                React.createElement(Spacer_1.Spacer, null)),
            React.createElement(BedPickerFlexWrapper, null,
                beds.map((bed, idx) => (React.createElement(BedPicker, { key: `bedroom-${id}-${bed.id}`, bedroomId: `bedroom-${id}`, index: idx, bed: bed, bedTypes: bedTypes, removeBed: removeBed, setBedType: setBedType }))),
                React.createElement(Spacer_1.Spacer, null)),
            React.createElement(Spacer_1.Spacer, { spacing: "smaller" }))));
};
exports.default = (props) => {
    // @ts-ignore https://github.com/microsoft/TypeScript/issues/42790
    const { entityActions } = React.useContext(__1.AppContext);
    const { itemTypes } = (0, data_1.useItemTypes)(entityActions);
    const { property, viewState, update, lastSaved, updaterError, getterError } = (0, autosave_1.useAutoSaveProperty)(props.propertyId);
    const { bedroomsEditState, dispatch } = (0, data_2.useBedrooms)((property === null || property === void 0 ? void 0 : property.beds) || [], update);
    React.useEffect(() => {
        const beds = Object.values(bedroomsEditState.rooms).reduce((collect, bedroom) => [...collect, ...bedroom.beds], bedroomsEditState.extraBeds);
        update({ beds, capacity: (0, capacity_1.estimateCapacity)(bedroomsEditState, itemTypes.bed_types) });
    }, [bedroomsEditState]);
    const [, errMsg] = (0, validation_1.useBedsValidation)('beds', property);
    const bedroomsCount = (!!bedroomsEditState) ? Object.keys(bedroomsEditState.rooms).length : 1;
    const extraBedsCount = (bedroomsEditState === null || bedroomsEditState === void 0 ? void 0 : bedroomsEditState.extraBeds.length) || 0;
    const extraBedsSubheading = extraBedsCount > 0
        ? `${extraBedsCount} bed${(extraBedsCount > 1) ? 's' : ''}`
        : 'No other beds';
    const capacityEstimate = (0, capacity_1.estimateCapacity)(bedroomsEditState, itemTypes.bed_types);
    const onBedroomsCountChange = (value) => {
        if (value > bedroomsCount) {
            dispatch({ type: 'newBedroom' });
        }
        else if (bedroomsCount > value) {
            dispatch({ type: 'removeBedroom' });
        }
    };
    return (React.createElement(TaskPage_1.TaskPage, { task: constants_1.Tasks.BEDROOMS, property: property, viewState: viewState, lastSaved: lastSaved, getterError: getterError, updaterError: updaterError, contextualMessage: errMsg },
        React.createElement(HorizontalRule_1.HorizontalRule, null),
        React.createElement(Spacer_1.Spacer, { spacing: "large" }),
        React.createElement(TaskPage_1.TaskLayout, null,
            React.createElement(TaskPage_1.TaskColumn, null,
                React.createElement(MarginWrapper_1.MarginWrapper, null,
                    React.createElement(Heading_1.HeadingSmall, null, "Number of bedrooms"),
                    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
                    React.createElement(Paragraph_1.Paragraph, { fillParent: "mid" }, "How many bedrooms does your property have?"),
                    React.createElement(Spacer_1.Spacer, null),
                    React.createElement(merlin_info_panels_1.DidYouKnow, { colour: "purple", id: "bedroom-number-info-bedroom-page", text: React.createElement("div", null,
                            "Only a studio property type supports 0 bedrooms. All other ",
                            React.createElement("a", { href: `https://account.travelnest.com/property/${props.propertyId}/edit/tasks/composition` }, "property types"),
                            " must have at least 1 bedroom.") }),
                    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
                    React.createElement(merlin_input_stepper_1.InputStepper, { id: "bedroom_count", onClick: onBedroomsCountChange, value: bedroomsCount, minValue: 0, valueFormatter: (value) => `${value} ${value > 1 ? 'bedrooms' : 'bedroom'}` })),
                React.createElement(Spacer_1.Spacer, { spacing: "large" }),
                !!bedroomsEditState
                    ? React.createElement(React.Fragment, null,
                        Object.values(bedroomsEditState.rooms).map((room, i) => React.createElement(BedroomEdit, { key: room.id, bedroomNumber: i + 1, bedroom: room, dispatch: dispatch, bedTypes: itemTypes === null || itemTypes === void 0 ? void 0 : itemTypes.bed_types })),
                        React.createElement(accordion_1.Accordion, { persistenceId: "tn-accordion-bedroomspage" },
                            React.createElement(accordion_1.AccordionHeader, null,
                                React.createElement(accordion_1.DefaultAccordionHeading, { heading: (property === null || property === void 0 ? void 0 : property.property_type) === 'studio' ? 'Studio sleeping area' : 'Other sleeping areas', subheading: extraBedsSubheading })),
                            React.createElement(accordion_1.AccordionItem, { noBorder: true },
                                React.createElement(IconButton_1.default, { icon: "plus", colour: "black", onClick: () => dispatch({ type: 'newExtraBed' }) }, (property === null || property === void 0 ? void 0 : property.property_type) === 'studio' ? 'Add bed' : 'Add extra bed'),
                                React.createElement(Spacer_1.Spacer, null),
                                React.createElement(BedPickerFlexWrapper, null, bedroomsEditState.extraBeds.map((bed, idx) => (React.createElement(React.Fragment, null,
                                    React.createElement(BedPicker, { key: bed.id, index: idx, bed: bed, bedroomId: "extra", bedTypes: itemTypes === null || itemTypes === void 0 ? void 0 : itemTypes.bed_types, removeBed: () => dispatch({ type: 'removeExtraBed', bed: idx }), setBedType: (bedType) => dispatch({ type: 'setBedType', bedType, bed: idx }) }),
                                    idx !== bedroomsEditState.extraBeds.length - 1 && React.createElement(Spacer_1.Spacer, { key: `${bed.id}${idx}-spacer` }))))),
                                React.createElement(Spacer_1.Spacer, { spacing: "smaller" }))))
                    : '',
                React.createElement(HorizontalRule_1.HorizontalRule, null),
                React.createElement(Spacer_1.Spacer, { spacing: "large" }),
                React.createElement(MarginWrapper_1.MarginWrapper, null,
                    React.createElement(Heading_1.HeadingSmall, null, "Maximum number of guests"),
                    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
                    React.createElement(Paragraph_1.Paragraph, null, "Based on the beds you have specified, we have calculated how many guests can stay."),
                    React.createElement(Spacer_1.Spacer, null),
                    React.createElement(merlin_info_panels_1.StatisticPanel, { label: "Maximum number of guests", value: capacityEstimate, colour: 'green' }))))));
};
//# sourceMappingURL=BedroomsPage.js.map